import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./WhyLaunchified2.css";

const WhyLaunchified2 = () => {
  return (
    <div className="grow-container container-fluid">
      <div className="row justify-content-center align-items-start text-center text-lg-start text-md-start">
        <div className="col-lg-11 col-md-11 col-sm-11">
          <h6 className="why-launchified2">Why Launchified</h6>
          <h1 className="main-heading">
            Aim high, engage fully,
            <br />
            <span>Grow Beyond Limits.</span>
          </h1>
          <p className="description">
            At Launch, our focus is on driving successful product launches
            through a proven model designed to help our clients thrive. We want
            you to understand how our <b>Aim, Engage, and Grow model</b>{" "}
            supports our clients at every step through our specially{" "}
            <b>crafted & designed</b> <br></br>Launchified courses.
          </p>
        </div>
      </div>
    </div>
  );
};
export default WhyLaunchified2;
